module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.4144/img/elite-tier-icon.svg"